<template>
    <div>
        <el-form :inline="true" :model="searchForm">
			<el-form-item label="提现单号：">
                <el-input v-model="searchForm.id" clearable></el-input>
            </el-form-item>
			 <el-form-item label="佣金类型：">
                <el-select v-model="searchForm.applyType" clearable>
                    <el-option value="0" label="普通佣金提现"></el-option>
                    <el-option value="1" label="号卡佣金提现"></el-option>
                  
                </el-select>
            </el-form-item>
            <el-form-item label="状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option value="0" label="未审批"></el-option>
                    <el-option value="1" label="已通过"></el-option>
                    <el-option value="2" label="未通过"></el-option>
                    <el-option value="3" label="已付款"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getCashOutApproveListHandler">查 询</el-button>
                <el-button type="success" plain icon="el-icon-download" @click="exportInfoHandle()">导 出</el-button>
                <el-upload class="upload-demo" ref="upload" :action="uploadUrl('agent/payment/confirmation')"  :headers="setHeader()" :limit="1"  :on-success = 'uploadSeccess' :show-file-list="false" :file-list="fileList" >
                    <el-button slot="trigger" icon="el-icon-upload2" plain type="primary">导 入</el-button>
                </el-upload>
            </el-form-item>
        </el-form>
        <!-- 代理商总返现金额 -->  
        <div    v-if="hasAuthority('update_balance')"  style="padding-bottom:10px;">代理商普通佣金 未提现金额还有：{{ allAgentPrice }}元</div>
        
        <el-table :data="tbpg.tableData"
		border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		  :default-sort = "{prop: 'createTime', order: 'descending'}">
            <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
            <el-table-column prop="id" label="提现单号" align="center" width="150"></el-table-column>
             <el-table-column  align="center"  label="佣金类型"  width="100px">
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.applyType==0"  :content="scope.row.applyTypeName">
                        <p style="color:green"> {{scope.row.applyTypeName}}</p>
                    </el-tooltip>
                     <el-tooltip v-else  :content="scope.row.applyTypeName" >
                        <p style="color:brown"> {{scope.row.applyTypeName}}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="agentName" label="代理商名称" align="center" width="120"></el-table-column>
            <el-table-column  align="center"  label="代理商路径"  width="120">
                 <template v-slot="scope">
                    <el-tooltip  :content="scope.row.pathName">
                        <p style="color:green"> {{scope.row.pathName}}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="申请时间" align="center" sortable width="150"></el-table-column>
            <el-table-column prop="priceRmb" label="提现金额（元）" align="center" width="120"></el-table-column>
            <el-table-column label="提现方式" width="100" align="center">
                <template v-slot="scope" >
                    {{scope.row.cashType==1?"支付宝":"银行卡"}}
                </template>
            </el-table-column>
			<el-table-column prop="payeeName" align="center" label="收款人" sortable width="100"></el-table-column>
			<el-table-column prop="payeeAccount" label="收款帐号" align="center" sortable width="150"></el-table-column>
            <el-table-column prop="feeRmb" label="提现手续费（元）" align="center" width="150"></el-table-column>
            <el-table-column prop="approveTime" label="审批时间" align="center" sortable width="150"></el-table-column>
            <el-table-column label="应到账金额（元）" align="center" width="140">
                <template v-slot="scope" >
                    <span >{{scope.row.priceRmb - scope.row.feeRmb}}</span>
                </template>
            </el-table-column>
            <el-table-column label="审批结果" width="100ß" align="center">
                <template v-slot="scope" >
                    <span v-if="scope.row.state=='2'" style="color: #8e8e8e">{{scope.row.stateName}}</span>
                    <span v-else-if="scope.row.state=='1' || scope.row.state=='3'" style="color: green">{{scope.row.stateName}}</span>
                    <span v-else style="color: red">{{scope.row.stateName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="审核操作" width="120" align="center" fixed="right">
                <template slot-scope="scope" v-if="scope.row.state==0" >
                    <el-button type="text" size="small"  @click="approveCashOutHandler(scope.row.id, 2)">
						<span style="color: red;">拒绝</span>
					</el-button>
                    <el-button type="text" size="small"  @click="approveCashOutHandler(scope.row.id, 1)">同意</el-button>
                </template>                
            </el-table-column>
        </el-table>
 <!-- 分页 -->
 <div class="pagination-container">
   <el-pagination
     :current-page="tbpg.currentPage"
     :page-sizes="[10,20,30, 40]"
     :page-size="tbpg.pageSize"
     :total="tbpg.total"
     background layout="total, sizes, prev, pager, next, jumper"
     @size-change="handleSizeChange"
     @current-change="handleCurrentChange"
   />
 </div>

                <el-dialog :append-to-body="true"  title="拒绝提现" :visible.sync="changePkgGroupVisible" width="600px"  @close="changePkgGroupCancel" :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm" label-width="120px">
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="searchForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changePkgGroupCancel">取 消</el-button>
                <el-button type="primary" @click="sureChangePkgGroupHandler">确 定</el-button>
            </div> 
        </el-dialog> 

    </div>
</template>
<script>
import {getCashOutApproveList, exportAgentCashoutList, cashOutApprove} from '@/api/finance.js';
import common from '@/utils/common.js';
import {mapGetters } from "vuex";
export default {
    data() {
        return {
               changePkgGroupVisible:false,
            searchForm: {
                applyType:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            confirmApplyDialogVisible: false,
            confirmApproveDialogVisible: false,
            priceRmb: '',
            dataApprove:{
                id:'',
                state: 1,
                remark:''
            },

            fileList: [],
            allAgentPrice: '' //代理商总返现金额
        }
    },
     computed:{
        ...mapGetters("menu", {
            hasAuthority: "hasAuthority" 
        }),

        fromPageIccid: function(){
            return this.$store.state.menu.iccidToAccount;
        },
    },

    methods: {
        getCashOutApproveListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getCashOutApproveList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
          changePkgGroupCancel(){
            this.changePkgGroupVisible = false;
        },


        approveCashOutHandler(id, state){
            this.dataApprove.id = id;
            this.dataApprove.state = state;

            //同意
            if(state==1){
                this.$confirm('确定同意提现吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    cashOutApprove(this.dataApprove).then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.getCashOutApproveListHandler();
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }).catch(() => {});
            }
            
            //拒绝
            else if(state==2){
                this.changePkgGroupVisible=true;
            }
        },
sureChangePkgGroupHandler(){
             this.dataApprove.remark = this.searchForm.remark;
             cashOutApprove(this.dataApprove).then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.getCashOutApproveListHandler();
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                     this.changePkgGroupVisible=false;
        },
        formatPrice(){
            this.priceRmb = this.priceRmb.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        },

        exportInfoHandle(){
            let _that = this;
            common.deleteSpaceKey(_that.searchForm); 

            this.$confirm('确定导出吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                exportAgentCashoutList(_that.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(()=>{});
        },


        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getCashOutApproveListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getCashOutApproveListHandler();
        },


        uploadSeccess(res, file){
            if(res.code == 200){
                this.$message.success(res.message);
                this.getCashOutApproveListHandler();
            }else{
                this.$message.error(res.message);
            }
            this.fileList = [];
        },



    },
    created () {
        this.getCashOutApproveListHandler();
        //获取代理商总返现金额
        common.sysRequest('agent/all/agent/price', {}, 'post').then(res => {
            if(res.data.code == 200){
                this.allAgentPrice = res.data.data/100;
            }
        })
    },

}
</script>
<style  lang="less" scoped>
    .priceDiv{
        margin-top: 20px;
        margin-bottom:50px;
        display: flex;

        .priceIcon{
            display: inline-block;
            flex: 1;
            height:35px;
            width:50px;
            line-height:35px;
            font-size:24px;
            text-align: center;
            border-bottom:1px solid #000;
        }

        .priceRmbInput{
            line-height:35px;
            flex: 1;
            height:35px;
            font-size: 28px;
            outline:none;
            border: none;
            border-bottom: 1px solid #000;
        }

        input:-ms-input-placeholder {
            font-size: 14px;
        }

        input::-moz-input-placeholder {
            font-size: 14px;
        }
        input::-webkit-input-placeholder {
            font-size: 14px;
        }
        input:-moz-placeholder{font-size: 14px;}                 
        input::-moz-placeholder{font-size: 14px;}                
        input:-ms-input-placeholder{font-size: 14px;}   


    }

    .upload-demo{
        display: inline-block;
        margin-left: 10px;
    }

</style>